/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AddCatalogProductsRequestInner,
  CatalogsOrganizationCatalogIdProductsProductIdMoveProductPutRequest,
  CatalogsOrganizationCatalogIdProductsProductIdPutRequest,
  CreateCatalogCategoryRequest,
  CreateCatalogRequest,
  CreateModifierRequest,
  CreateProductRequest,
  GetCatalog200Response,
  GetCategories200ResponseInner,
  GetModifierGroup200Response,
  GetModifierGroups200Response,
  GetModifiers200Response,
  GetOrganizationCombo200Response,
  GetOrganizationCombos200Response,
  GetProducts200Response,
  GetProductsFiltersParameterInnerInner,
  GetProductsPaginationParameter,
  GetProductsSortingParameterInner,
  PatchModifierGroupRequest,
  PatchModifierRequest,
  PatchOrganizationComboRequest,
  PatchOrganizationCombosBulkRequest,
  PatchOrganizationCombosRequestInner,
  PatchProductRequest,
  PatchProductsBulkRequest,
  PatchProductsRequestInner,
  UpdateCatalogCategoryRequest,
  UpdateCatalogDetailsRequest,
  UpdateCatalogModifierGroupRequest,
  UpdateModifierGroupRequest,
  UpdateModifierGroupsRequestInner,
  UpdateModifiersRequestInner,
  UpdateOrganizationComboRequest,
} from '../models/index';
import {
    AddCatalogProductsRequestInnerFromJSON,
    AddCatalogProductsRequestInnerToJSON,
    CatalogsOrganizationCatalogIdProductsProductIdMoveProductPutRequestFromJSON,
    CatalogsOrganizationCatalogIdProductsProductIdMoveProductPutRequestToJSON,
    CatalogsOrganizationCatalogIdProductsProductIdPutRequestFromJSON,
    CatalogsOrganizationCatalogIdProductsProductIdPutRequestToJSON,
    CreateCatalogCategoryRequestFromJSON,
    CreateCatalogCategoryRequestToJSON,
    CreateCatalogRequestFromJSON,
    CreateCatalogRequestToJSON,
    CreateModifierRequestFromJSON,
    CreateModifierRequestToJSON,
    CreateProductRequestFromJSON,
    CreateProductRequestToJSON,
    GetCatalog200ResponseFromJSON,
    GetCatalog200ResponseToJSON,
    GetCategories200ResponseInnerFromJSON,
    GetCategories200ResponseInnerToJSON,
    GetModifierGroup200ResponseFromJSON,
    GetModifierGroup200ResponseToJSON,
    GetModifierGroups200ResponseFromJSON,
    GetModifierGroups200ResponseToJSON,
    GetModifiers200ResponseFromJSON,
    GetModifiers200ResponseToJSON,
    GetOrganizationCombo200ResponseFromJSON,
    GetOrganizationCombo200ResponseToJSON,
    GetOrganizationCombos200ResponseFromJSON,
    GetOrganizationCombos200ResponseToJSON,
    GetProducts200ResponseFromJSON,
    GetProducts200ResponseToJSON,
    GetProductsFiltersParameterInnerInnerFromJSON,
    GetProductsFiltersParameterInnerInnerToJSON,
    GetProductsPaginationParameterFromJSON,
    GetProductsPaginationParameterToJSON,
    GetProductsSortingParameterInnerFromJSON,
    GetProductsSortingParameterInnerToJSON,
    PatchModifierGroupRequestFromJSON,
    PatchModifierGroupRequestToJSON,
    PatchModifierRequestFromJSON,
    PatchModifierRequestToJSON,
    PatchOrganizationComboRequestFromJSON,
    PatchOrganizationComboRequestToJSON,
    PatchOrganizationCombosBulkRequestFromJSON,
    PatchOrganizationCombosBulkRequestToJSON,
    PatchOrganizationCombosRequestInnerFromJSON,
    PatchOrganizationCombosRequestInnerToJSON,
    PatchProductRequestFromJSON,
    PatchProductRequestToJSON,
    PatchProductsBulkRequestFromJSON,
    PatchProductsBulkRequestToJSON,
    PatchProductsRequestInnerFromJSON,
    PatchProductsRequestInnerToJSON,
    UpdateCatalogCategoryRequestFromJSON,
    UpdateCatalogCategoryRequestToJSON,
    UpdateCatalogDetailsRequestFromJSON,
    UpdateCatalogDetailsRequestToJSON,
    UpdateCatalogModifierGroupRequestFromJSON,
    UpdateCatalogModifierGroupRequestToJSON,
    UpdateModifierGroupRequestFromJSON,
    UpdateModifierGroupRequestToJSON,
    UpdateModifierGroupsRequestInnerFromJSON,
    UpdateModifierGroupsRequestInnerToJSON,
    UpdateModifiersRequestInnerFromJSON,
    UpdateModifiersRequestInnerToJSON,
    UpdateOrganizationComboRequestFromJSON,
    UpdateOrganizationComboRequestToJSON,
} from '../models/index';

export interface AddCatalogProductsRequest {
    catalogId: string;
    categoryId: string;
    addCatalogProductsRequestInner?: Array<AddCatalogProductsRequestInner>;
}

export interface CatalogsOrganizationCatalogIdProductsProductIdMoveProductPutOperationRequest {
    catalogId: string;
    productId: string;
    catalogsOrganizationCatalogIdProductsProductIdMoveProductPutRequest: CatalogsOrganizationCatalogIdProductsProductIdMoveProductPutRequest;
}

export interface CatalogsOrganizationCatalogIdProductsProductIdPutOperationRequest {
    catalogId: string;
    productId: string;
    catalogsOrganizationCatalogIdProductsProductIdPutRequest: CatalogsOrganizationCatalogIdProductsProductIdPutRequest;
}

export interface CreateCatalogOperationRequest {
    createCatalogRequest: CreateCatalogRequest;
}

export interface CreateCatalogCategoryOperationRequest {
    catalogId: string;
    createCatalogCategoryRequest: CreateCatalogCategoryRequest;
}

export interface CreateCourseRequest {
    createCatalogRequest: CreateCatalogRequest;
}

export interface CreateModifierOperationRequest {
    createModifierRequest: CreateModifierRequest;
}

export interface CreateModifierGroupRequest {
    updateModifierGroupRequest: UpdateModifierGroupRequest;
}

export interface CreateOrganizationComboRequest {
    updateOrganizationComboRequest: UpdateOrganizationComboRequest;
}

export interface CreateProductOperationRequest {
    createProductRequest: CreateProductRequest;
}

export interface DeleteCatalogRequest {
    catalogId: string;
}

export interface DeleteCatalogCategoryRequest {
    catalogId: string;
    categoryId: string;
}

export interface DeleteCatalogProductRequest {
    catalogId: string;
    productId: string;
}

export interface DeleteCourseRequest {
    courseId: string;
}

export interface DeleteModifierRequest {
    modifierId: string;
}

export interface DeleteModifierGroupRequest {
    modifierGroupId: string;
}

export interface DeleteOrganizationComboRequest {
    comboId: string;
}

export interface DeleteProductRequest {
    productId: string;
}

export interface DuplicateCatalogRequest {
    catalogId: string;
}

export interface GetCatalogRequest {
    catalogId: string;
}

export interface GetModifierGroupRequest {
    modifierGroupId: string;
}

export interface GetModifierGroupsRequest {
    pagination?: GetProductsPaginationParameter;
    filters?: Array<Array<GetProductsFiltersParameterInnerInner>>;
    sorting?: Array<GetProductsSortingParameterInner>;
    startDate?: Date;
    endDate?: Date;
}

export interface GetModifiersRequest {
    pagination?: GetProductsPaginationParameter;
    filters?: Array<Array<GetProductsFiltersParameterInnerInner>>;
    sorting?: Array<GetProductsSortingParameterInner>;
    startDate?: Date;
    endDate?: Date;
}

export interface GetOrganizationComboRequest {
    comboId: string;
}

export interface GetOrganizationCombosRequest {
    pagination?: GetProductsPaginationParameter;
    filters?: Array<Array<GetProductsFiltersParameterInnerInner>>;
    sorting?: Array<GetProductsSortingParameterInner>;
    startDate?: Date;
    endDate?: Date;
}

export interface GetProductsRequest {
    pagination?: GetProductsPaginationParameter;
    filters?: Array<Array<GetProductsFiltersParameterInnerInner>>;
    sorting?: Array<GetProductsSortingParameterInner>;
    startDate?: Date;
    endDate?: Date;
}

export interface PatchModifierOperationRequest {
    modifierId: string;
    patchModifierRequest?: PatchModifierRequest;
}

export interface PatchModifierGroupOperationRequest {
    modifierGroupId: string;
    patchModifierGroupRequest?: PatchModifierGroupRequest;
}

export interface PatchOrganizationComboOperationRequest {
    comboId: string;
    patchOrganizationComboRequest?: PatchOrganizationComboRequest;
}

export interface PatchOrganizationCombosRequest {
    patchOrganizationCombosRequestInner?: Array<PatchOrganizationCombosRequestInner>;
}

export interface PatchOrganizationCombosBulkOperationRequest {
    patchOrganizationCombosBulkRequest: PatchOrganizationCombosBulkRequest;
}

export interface PatchProductOperationRequest {
    productId: string;
    patchProductRequest?: PatchProductRequest;
}

export interface PatchProductsRequest {
    patchProductsRequestInner?: Array<PatchProductsRequestInner>;
}

export interface PatchProductsBulkOperationRequest {
    patchProductsBulkRequest: PatchProductsBulkRequest;
}

export interface SortCategoriesRequest {
    catalogId: string;
    requestBody?: Array<string>;
}

export interface UpdateCatalogCategoryOperationRequest {
    catalogId: string;
    categoryId: string;
    updateCatalogCategoryRequest: UpdateCatalogCategoryRequest;
}

export interface UpdateCatalogDetailsOperationRequest {
    catalogId: string;
    updateCatalogDetailsRequest: UpdateCatalogDetailsRequest;
}

export interface UpdateCatalogModifierGroupOperationRequest {
    catalogId: string;
    groupId: string;
    updateCatalogModifierGroupRequest: UpdateCatalogModifierGroupRequest;
}

export interface UpdateCourseRequest {
    courseId: string;
    updateCatalogDetailsRequest: UpdateCatalogDetailsRequest;
}

export interface UpdateCoursesRequest {
    createCatalogRequest?: Array<CreateCatalogRequest>;
}

export interface UpdateModifierRequest {
    modifierId: string;
    createModifierRequest: CreateModifierRequest;
}

export interface UpdateModifierGroupOperationRequest {
    modifierGroupId: string;
    updateModifierGroupRequest: UpdateModifierGroupRequest;
}

export interface UpdateModifierGroupsRequest {
    updateModifierGroupsRequestInner?: Array<UpdateModifierGroupsRequestInner>;
}

export interface UpdateModifiersRequest {
    updateModifiersRequestInner?: Array<UpdateModifiersRequestInner>;
}

export interface UpdateOrganizationComboOperationRequest {
    comboId: string;
    updateOrganizationComboRequest: UpdateOrganizationComboRequest;
}

export interface UpdateProductRequest {
    productId: string;
    createProductRequest: CreateProductRequest;
}

/**
 * 
 */
export class OrganizationCatalogApi extends runtime.BaseAPI {

    /**
     */
    async addCatalogProductsRaw(requestParameters: AddCatalogProductsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['catalogId'] == null) {
            throw new runtime.RequiredError(
                'catalogId',
                'Required parameter "catalogId" was null or undefined when calling addCatalogProducts().'
            );
        }

        if (requestParameters['categoryId'] == null) {
            throw new runtime.RequiredError(
                'categoryId',
                'Required parameter "categoryId" was null or undefined when calling addCatalogProducts().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/catalogs/organization/{catalogId}/categories/{categoryId}/products`.replace(`{${"catalogId"}}`, encodeURIComponent(String(requestParameters['catalogId']))).replace(`{${"categoryId"}}`, encodeURIComponent(String(requestParameters['categoryId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['addCatalogProductsRequestInner']!.map(AddCatalogProductsRequestInnerToJSON),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async addCatalogProducts(requestParameters: AddCatalogProductsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.addCatalogProductsRaw(requestParameters, initOverrides);
    }

    /**
     */
    async catalogsOrganizationCatalogIdProductsProductIdMoveProductPutRaw(requestParameters: CatalogsOrganizationCatalogIdProductsProductIdMoveProductPutOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['catalogId'] == null) {
            throw new runtime.RequiredError(
                'catalogId',
                'Required parameter "catalogId" was null or undefined when calling catalogsOrganizationCatalogIdProductsProductIdMoveProductPut().'
            );
        }

        if (requestParameters['productId'] == null) {
            throw new runtime.RequiredError(
                'productId',
                'Required parameter "productId" was null or undefined when calling catalogsOrganizationCatalogIdProductsProductIdMoveProductPut().'
            );
        }

        if (requestParameters['catalogsOrganizationCatalogIdProductsProductIdMoveProductPutRequest'] == null) {
            throw new runtime.RequiredError(
                'catalogsOrganizationCatalogIdProductsProductIdMoveProductPutRequest',
                'Required parameter "catalogsOrganizationCatalogIdProductsProductIdMoveProductPutRequest" was null or undefined when calling catalogsOrganizationCatalogIdProductsProductIdMoveProductPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/catalogs/organization/{catalogId}/products/{productId}/move-product`.replace(`{${"catalogId"}}`, encodeURIComponent(String(requestParameters['catalogId']))).replace(`{${"productId"}}`, encodeURIComponent(String(requestParameters['productId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CatalogsOrganizationCatalogIdProductsProductIdMoveProductPutRequestToJSON(requestParameters['catalogsOrganizationCatalogIdProductsProductIdMoveProductPutRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async catalogsOrganizationCatalogIdProductsProductIdMoveProductPut(requestParameters: CatalogsOrganizationCatalogIdProductsProductIdMoveProductPutOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.catalogsOrganizationCatalogIdProductsProductIdMoveProductPutRaw(requestParameters, initOverrides);
    }

    /**
     */
    async catalogsOrganizationCatalogIdProductsProductIdPutRaw(requestParameters: CatalogsOrganizationCatalogIdProductsProductIdPutOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['catalogId'] == null) {
            throw new runtime.RequiredError(
                'catalogId',
                'Required parameter "catalogId" was null or undefined when calling catalogsOrganizationCatalogIdProductsProductIdPut().'
            );
        }

        if (requestParameters['productId'] == null) {
            throw new runtime.RequiredError(
                'productId',
                'Required parameter "productId" was null or undefined when calling catalogsOrganizationCatalogIdProductsProductIdPut().'
            );
        }

        if (requestParameters['catalogsOrganizationCatalogIdProductsProductIdPutRequest'] == null) {
            throw new runtime.RequiredError(
                'catalogsOrganizationCatalogIdProductsProductIdPutRequest',
                'Required parameter "catalogsOrganizationCatalogIdProductsProductIdPutRequest" was null or undefined when calling catalogsOrganizationCatalogIdProductsProductIdPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/catalogs/organization/{catalogId}/products/{productId}`.replace(`{${"catalogId"}}`, encodeURIComponent(String(requestParameters['catalogId']))).replace(`{${"productId"}}`, encodeURIComponent(String(requestParameters['productId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CatalogsOrganizationCatalogIdProductsProductIdPutRequestToJSON(requestParameters['catalogsOrganizationCatalogIdProductsProductIdPutRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async catalogsOrganizationCatalogIdProductsProductIdPut(requestParameters: CatalogsOrganizationCatalogIdProductsProductIdPutOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.catalogsOrganizationCatalogIdProductsProductIdPutRaw(requestParameters, initOverrides);
    }

    /**
     */
    async createCatalogRaw(requestParameters: CreateCatalogOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['createCatalogRequest'] == null) {
            throw new runtime.RequiredError(
                'createCatalogRequest',
                'Required parameter "createCatalogRequest" was null or undefined when calling createCatalog().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/catalogs/organization/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateCatalogRequestToJSON(requestParameters['createCatalogRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async createCatalog(requestParameters: CreateCatalogOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createCatalogRaw(requestParameters, initOverrides);
    }

    /**
     */
    async createCatalogCategoryRaw(requestParameters: CreateCatalogCategoryOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['catalogId'] == null) {
            throw new runtime.RequiredError(
                'catalogId',
                'Required parameter "catalogId" was null or undefined when calling createCatalogCategory().'
            );
        }

        if (requestParameters['createCatalogCategoryRequest'] == null) {
            throw new runtime.RequiredError(
                'createCatalogCategoryRequest',
                'Required parameter "createCatalogCategoryRequest" was null or undefined when calling createCatalogCategory().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/catalogs/organization/{catalogId}/categories`.replace(`{${"catalogId"}}`, encodeURIComponent(String(requestParameters['catalogId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateCatalogCategoryRequestToJSON(requestParameters['createCatalogCategoryRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async createCatalogCategory(requestParameters: CreateCatalogCategoryOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createCatalogCategoryRaw(requestParameters, initOverrides);
    }

    /**
     */
    async createCourseRaw(requestParameters: CreateCourseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['createCatalogRequest'] == null) {
            throw new runtime.RequiredError(
                'createCatalogRequest',
                'Required parameter "createCatalogRequest" was null or undefined when calling createCourse().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/catalogs/organization/course`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateCatalogRequestToJSON(requestParameters['createCatalogRequest']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async createCourse(requestParameters: CreateCourseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.createCourseRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async createModifierRaw(requestParameters: CreateModifierOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['createModifierRequest'] == null) {
            throw new runtime.RequiredError(
                'createModifierRequest',
                'Required parameter "createModifierRequest" was null or undefined when calling createModifier().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/catalogs/organization/modifier`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateModifierRequestToJSON(requestParameters['createModifierRequest']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async createModifier(requestParameters: CreateModifierOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.createModifierRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async createModifierGroupRaw(requestParameters: CreateModifierGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['updateModifierGroupRequest'] == null) {
            throw new runtime.RequiredError(
                'updateModifierGroupRequest',
                'Required parameter "updateModifierGroupRequest" was null or undefined when calling createModifierGroup().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/catalogs/organization/modifier-group`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateModifierGroupRequestToJSON(requestParameters['updateModifierGroupRequest']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async createModifierGroup(requestParameters: CreateModifierGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.createModifierGroupRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async createOrganizationComboRaw(requestParameters: CreateOrganizationComboRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['updateOrganizationComboRequest'] == null) {
            throw new runtime.RequiredError(
                'updateOrganizationComboRequest',
                'Required parameter "updateOrganizationComboRequest" was null or undefined when calling createOrganizationCombo().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/catalogs/organization/combo`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateOrganizationComboRequestToJSON(requestParameters['updateOrganizationComboRequest']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async createOrganizationCombo(requestParameters: CreateOrganizationComboRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.createOrganizationComboRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async createProductRaw(requestParameters: CreateProductOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['createProductRequest'] == null) {
            throw new runtime.RequiredError(
                'createProductRequest',
                'Required parameter "createProductRequest" was null or undefined when calling createProduct().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/catalogs/organization/product`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateProductRequestToJSON(requestParameters['createProductRequest']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async createProduct(requestParameters: CreateProductOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.createProductRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async deleteCatalogRaw(requestParameters: DeleteCatalogRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['catalogId'] == null) {
            throw new runtime.RequiredError(
                'catalogId',
                'Required parameter "catalogId" was null or undefined when calling deleteCatalog().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/catalogs/organization/{catalogId}`.replace(`{${"catalogId"}}`, encodeURIComponent(String(requestParameters['catalogId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteCatalog(requestParameters: DeleteCatalogRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteCatalogRaw(requestParameters, initOverrides);
    }

    /**
     */
    async deleteCatalogCategoryRaw(requestParameters: DeleteCatalogCategoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['catalogId'] == null) {
            throw new runtime.RequiredError(
                'catalogId',
                'Required parameter "catalogId" was null or undefined when calling deleteCatalogCategory().'
            );
        }

        if (requestParameters['categoryId'] == null) {
            throw new runtime.RequiredError(
                'categoryId',
                'Required parameter "categoryId" was null or undefined when calling deleteCatalogCategory().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/catalogs/organization/{catalogId}/categories/{categoryId}`.replace(`{${"catalogId"}}`, encodeURIComponent(String(requestParameters['catalogId']))).replace(`{${"categoryId"}}`, encodeURIComponent(String(requestParameters['categoryId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteCatalogCategory(requestParameters: DeleteCatalogCategoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteCatalogCategoryRaw(requestParameters, initOverrides);
    }

    /**
     */
    async deleteCatalogProductRaw(requestParameters: DeleteCatalogProductRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['catalogId'] == null) {
            throw new runtime.RequiredError(
                'catalogId',
                'Required parameter "catalogId" was null or undefined when calling deleteCatalogProduct().'
            );
        }

        if (requestParameters['productId'] == null) {
            throw new runtime.RequiredError(
                'productId',
                'Required parameter "productId" was null or undefined when calling deleteCatalogProduct().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/catalogs/organization/{catalogId}/products/{productId}`.replace(`{${"catalogId"}}`, encodeURIComponent(String(requestParameters['catalogId']))).replace(`{${"productId"}}`, encodeURIComponent(String(requestParameters['productId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteCatalogProduct(requestParameters: DeleteCatalogProductRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteCatalogProductRaw(requestParameters, initOverrides);
    }

    /**
     */
    async deleteCourseRaw(requestParameters: DeleteCourseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['courseId'] == null) {
            throw new runtime.RequiredError(
                'courseId',
                'Required parameter "courseId" was null or undefined when calling deleteCourse().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/catalogs/organization/course/{courseId}`.replace(`{${"courseId"}}`, encodeURIComponent(String(requestParameters['courseId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteCourse(requestParameters: DeleteCourseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteCourseRaw(requestParameters, initOverrides);
    }

    /**
     */
    async deleteModifierRaw(requestParameters: DeleteModifierRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['modifierId'] == null) {
            throw new runtime.RequiredError(
                'modifierId',
                'Required parameter "modifierId" was null or undefined when calling deleteModifier().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/catalogs/organization/modifier/{modifierId}`.replace(`{${"modifierId"}}`, encodeURIComponent(String(requestParameters['modifierId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteModifier(requestParameters: DeleteModifierRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteModifierRaw(requestParameters, initOverrides);
    }

    /**
     */
    async deleteModifierGroupRaw(requestParameters: DeleteModifierGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['modifierGroupId'] == null) {
            throw new runtime.RequiredError(
                'modifierGroupId',
                'Required parameter "modifierGroupId" was null or undefined when calling deleteModifierGroup().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/catalogs/organization/modifier-group/{modifierGroupId}`.replace(`{${"modifierGroupId"}}`, encodeURIComponent(String(requestParameters['modifierGroupId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteModifierGroup(requestParameters: DeleteModifierGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteModifierGroupRaw(requestParameters, initOverrides);
    }

    /**
     */
    async deleteOrganizationComboRaw(requestParameters: DeleteOrganizationComboRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['comboId'] == null) {
            throw new runtime.RequiredError(
                'comboId',
                'Required parameter "comboId" was null or undefined when calling deleteOrganizationCombo().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/catalogs/organization/combo/{comboId}`.replace(`{${"comboId"}}`, encodeURIComponent(String(requestParameters['comboId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteOrganizationCombo(requestParameters: DeleteOrganizationComboRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteOrganizationComboRaw(requestParameters, initOverrides);
    }

    /**
     */
    async deleteProductRaw(requestParameters: DeleteProductRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['productId'] == null) {
            throw new runtime.RequiredError(
                'productId',
                'Required parameter "productId" was null or undefined when calling deleteProduct().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/catalogs/organization/product/{productId}`.replace(`{${"productId"}}`, encodeURIComponent(String(requestParameters['productId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteProduct(requestParameters: DeleteProductRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteProductRaw(requestParameters, initOverrides);
    }

    /**
     */
    async duplicateCatalogRaw(requestParameters: DuplicateCatalogRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['catalogId'] == null) {
            throw new runtime.RequiredError(
                'catalogId',
                'Required parameter "catalogId" was null or undefined when calling duplicateCatalog().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/catalogs/organization/{catalogId}/duplicate`.replace(`{${"catalogId"}}`, encodeURIComponent(String(requestParameters['catalogId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async duplicateCatalog(requestParameters: DuplicateCatalogRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.duplicateCatalogRaw(requestParameters, initOverrides);
    }

    /**
     */
    async getCatalogRaw(requestParameters: GetCatalogRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetCatalog200Response>> {
        if (requestParameters['catalogId'] == null) {
            throw new runtime.RequiredError(
                'catalogId',
                'Required parameter "catalogId" was null or undefined when calling getCatalog().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/catalogs/organization/{catalogId}`.replace(`{${"catalogId"}}`, encodeURIComponent(String(requestParameters['catalogId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetCatalog200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async getCatalog(requestParameters: GetCatalogRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetCatalog200Response> {
        const response = await this.getCatalogRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getCategoriesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetCategories200ResponseInner>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/catalogs/organization/categories`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetCategories200ResponseInnerFromJSON));
    }

    /**
     */
    async getCategories(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetCategories200ResponseInner>> {
        const response = await this.getCategoriesRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getCoursesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CreateCatalogRequest>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/catalogs/organization/courses`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CreateCatalogRequestFromJSON));
    }

    /**
     */
    async getCourses(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CreateCatalogRequest>> {
        const response = await this.getCoursesRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getModifierGroupRaw(requestParameters: GetModifierGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetModifierGroup200Response>> {
        if (requestParameters['modifierGroupId'] == null) {
            throw new runtime.RequiredError(
                'modifierGroupId',
                'Required parameter "modifierGroupId" was null or undefined when calling getModifierGroup().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/catalogs/organization/modifier-group/{modifierGroupId}`.replace(`{${"modifierGroupId"}}`, encodeURIComponent(String(requestParameters['modifierGroupId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetModifierGroup200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async getModifierGroup(requestParameters: GetModifierGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetModifierGroup200Response> {
        const response = await this.getModifierGroupRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getModifierGroupsRaw(requestParameters: GetModifierGroupsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetModifierGroups200Response>> {
        const queryParameters: any = {};

        if (requestParameters['pagination'] != null) {
            queryParameters['pagination'] = requestParameters['pagination'];
        }

        if (requestParameters['filters'] != null) {
            queryParameters['filters'] = requestParameters['filters'];
        }

        if (requestParameters['sorting'] != null) {
            queryParameters['sorting'] = requestParameters['sorting'];
        }

        if (requestParameters['startDate'] != null) {
            queryParameters['startDate'] = (requestParameters['startDate'] as any).toISOString();
        }

        if (requestParameters['endDate'] != null) {
            queryParameters['endDate'] = (requestParameters['endDate'] as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/catalogs/organization/modifier-groups`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetModifierGroups200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async getModifierGroups(requestParameters: GetModifierGroupsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetModifierGroups200Response> {
        const response = await this.getModifierGroupsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getModifierGroupsNamesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CreateCatalogRequest>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/catalogs/organization/modifier-groups/names`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CreateCatalogRequestFromJSON));
    }

    /**
     */
    async getModifierGroupsNames(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CreateCatalogRequest>> {
        const response = await this.getModifierGroupsNamesRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getModifierNamesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CreateCatalogRequest>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/catalogs/organization/modifiers/names`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CreateCatalogRequestFromJSON));
    }

    /**
     */
    async getModifierNames(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CreateCatalogRequest>> {
        const response = await this.getModifierNamesRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getModifiersRaw(requestParameters: GetModifiersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetModifiers200Response>> {
        const queryParameters: any = {};

        if (requestParameters['pagination'] != null) {
            queryParameters['pagination'] = requestParameters['pagination'];
        }

        if (requestParameters['filters'] != null) {
            queryParameters['filters'] = requestParameters['filters'];
        }

        if (requestParameters['sorting'] != null) {
            queryParameters['sorting'] = requestParameters['sorting'];
        }

        if (requestParameters['startDate'] != null) {
            queryParameters['startDate'] = (requestParameters['startDate'] as any).toISOString();
        }

        if (requestParameters['endDate'] != null) {
            queryParameters['endDate'] = (requestParameters['endDate'] as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/catalogs/organization/modifiers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetModifiers200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async getModifiers(requestParameters: GetModifiersRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetModifiers200Response> {
        const response = await this.getModifiersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getOrganizationComboRaw(requestParameters: GetOrganizationComboRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetOrganizationCombo200Response>> {
        if (requestParameters['comboId'] == null) {
            throw new runtime.RequiredError(
                'comboId',
                'Required parameter "comboId" was null or undefined when calling getOrganizationCombo().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/catalogs/organization/combo/{comboId}`.replace(`{${"comboId"}}`, encodeURIComponent(String(requestParameters['comboId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetOrganizationCombo200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async getOrganizationCombo(requestParameters: GetOrganizationComboRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetOrganizationCombo200Response> {
        const response = await this.getOrganizationComboRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getOrganizationCombosRaw(requestParameters: GetOrganizationCombosRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetOrganizationCombos200Response>> {
        const queryParameters: any = {};

        if (requestParameters['pagination'] != null) {
            queryParameters['pagination'] = requestParameters['pagination'];
        }

        if (requestParameters['filters'] != null) {
            queryParameters['filters'] = requestParameters['filters'];
        }

        if (requestParameters['sorting'] != null) {
            queryParameters['sorting'] = requestParameters['sorting'];
        }

        if (requestParameters['startDate'] != null) {
            queryParameters['startDate'] = (requestParameters['startDate'] as any).toISOString();
        }

        if (requestParameters['endDate'] != null) {
            queryParameters['endDate'] = (requestParameters['endDate'] as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/catalogs/organization/combos`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetOrganizationCombos200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async getOrganizationCombos(requestParameters: GetOrganizationCombosRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetOrganizationCombos200Response> {
        const response = await this.getOrganizationCombosRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getProductsRaw(requestParameters: GetProductsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetProducts200Response>> {
        const queryParameters: any = {};

        if (requestParameters['pagination'] != null) {
            queryParameters['pagination'] = requestParameters['pagination'];
        }

        if (requestParameters['filters'] != null) {
            queryParameters['filters'] = requestParameters['filters'];
        }

        if (requestParameters['sorting'] != null) {
            queryParameters['sorting'] = requestParameters['sorting'];
        }

        if (requestParameters['startDate'] != null) {
            queryParameters['startDate'] = (requestParameters['startDate'] as any).toISOString();
        }

        if (requestParameters['endDate'] != null) {
            queryParameters['endDate'] = (requestParameters['endDate'] as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/catalogs/organization/products`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetProducts200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async getProducts(requestParameters: GetProductsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetProducts200Response> {
        const response = await this.getProductsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async patchModifierRaw(requestParameters: PatchModifierOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['modifierId'] == null) {
            throw new runtime.RequiredError(
                'modifierId',
                'Required parameter "modifierId" was null or undefined when calling patchModifier().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/catalogs/organization/modifier/{modifierId}`.replace(`{${"modifierId"}}`, encodeURIComponent(String(requestParameters['modifierId']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchModifierRequestToJSON(requestParameters['patchModifierRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async patchModifier(requestParameters: PatchModifierOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.patchModifierRaw(requestParameters, initOverrides);
    }

    /**
     */
    async patchModifierGroupRaw(requestParameters: PatchModifierGroupOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['modifierGroupId'] == null) {
            throw new runtime.RequiredError(
                'modifierGroupId',
                'Required parameter "modifierGroupId" was null or undefined when calling patchModifierGroup().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/catalogs/organization/modifier-group/{modifierGroupId}`.replace(`{${"modifierGroupId"}}`, encodeURIComponent(String(requestParameters['modifierGroupId']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchModifierGroupRequestToJSON(requestParameters['patchModifierGroupRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async patchModifierGroup(requestParameters: PatchModifierGroupOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.patchModifierGroupRaw(requestParameters, initOverrides);
    }

    /**
     */
    async patchOrganizationComboRaw(requestParameters: PatchOrganizationComboOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['comboId'] == null) {
            throw new runtime.RequiredError(
                'comboId',
                'Required parameter "comboId" was null or undefined when calling patchOrganizationCombo().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/catalogs/organization/combo/{comboId}`.replace(`{${"comboId"}}`, encodeURIComponent(String(requestParameters['comboId']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchOrganizationComboRequestToJSON(requestParameters['patchOrganizationComboRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async patchOrganizationCombo(requestParameters: PatchOrganizationComboOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.patchOrganizationComboRaw(requestParameters, initOverrides);
    }

    /**
     */
    async patchOrganizationCombosRaw(requestParameters: PatchOrganizationCombosRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/catalogs/organization/combos`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['patchOrganizationCombosRequestInner']!.map(PatchOrganizationCombosRequestInnerToJSON),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async patchOrganizationCombos(requestParameters: PatchOrganizationCombosRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.patchOrganizationCombosRaw(requestParameters, initOverrides);
    }

    /**
     */
    async patchOrganizationCombosBulkRaw(requestParameters: PatchOrganizationCombosBulkOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['patchOrganizationCombosBulkRequest'] == null) {
            throw new runtime.RequiredError(
                'patchOrganizationCombosBulkRequest',
                'Required parameter "patchOrganizationCombosBulkRequest" was null or undefined when calling patchOrganizationCombosBulk().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/catalogs/organization/combos/bulk`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchOrganizationCombosBulkRequestToJSON(requestParameters['patchOrganizationCombosBulkRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async patchOrganizationCombosBulk(requestParameters: PatchOrganizationCombosBulkOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.patchOrganizationCombosBulkRaw(requestParameters, initOverrides);
    }

    /**
     */
    async patchProductRaw(requestParameters: PatchProductOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['productId'] == null) {
            throw new runtime.RequiredError(
                'productId',
                'Required parameter "productId" was null or undefined when calling patchProduct().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/catalogs/organization/product/{productId}`.replace(`{${"productId"}}`, encodeURIComponent(String(requestParameters['productId']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchProductRequestToJSON(requestParameters['patchProductRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async patchProduct(requestParameters: PatchProductOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.patchProductRaw(requestParameters, initOverrides);
    }

    /**
     */
    async patchProductsRaw(requestParameters: PatchProductsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/catalogs/organization/products`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['patchProductsRequestInner']!.map(PatchProductsRequestInnerToJSON),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async patchProducts(requestParameters: PatchProductsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.patchProductsRaw(requestParameters, initOverrides);
    }

    /**
     */
    async patchProductsBulkRaw(requestParameters: PatchProductsBulkOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['patchProductsBulkRequest'] == null) {
            throw new runtime.RequiredError(
                'patchProductsBulkRequest',
                'Required parameter "patchProductsBulkRequest" was null or undefined when calling patchProductsBulk().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/catalogs/organization/products/bulk`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchProductsBulkRequestToJSON(requestParameters['patchProductsBulkRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async patchProductsBulk(requestParameters: PatchProductsBulkOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.patchProductsBulkRaw(requestParameters, initOverrides);
    }

    /**
     */
    async sortCategoriesRaw(requestParameters: SortCategoriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['catalogId'] == null) {
            throw new runtime.RequiredError(
                'catalogId',
                'Required parameter "catalogId" was null or undefined when calling sortCategories().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/catalogs/organization/{catalogId}/categories/sort`.replace(`{${"catalogId"}}`, encodeURIComponent(String(requestParameters['catalogId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async sortCategories(requestParameters: SortCategoriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.sortCategoriesRaw(requestParameters, initOverrides);
    }

    /**
     */
    async updateCatalogCategoryRaw(requestParameters: UpdateCatalogCategoryOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['catalogId'] == null) {
            throw new runtime.RequiredError(
                'catalogId',
                'Required parameter "catalogId" was null or undefined when calling updateCatalogCategory().'
            );
        }

        if (requestParameters['categoryId'] == null) {
            throw new runtime.RequiredError(
                'categoryId',
                'Required parameter "categoryId" was null or undefined when calling updateCatalogCategory().'
            );
        }

        if (requestParameters['updateCatalogCategoryRequest'] == null) {
            throw new runtime.RequiredError(
                'updateCatalogCategoryRequest',
                'Required parameter "updateCatalogCategoryRequest" was null or undefined when calling updateCatalogCategory().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/catalogs/organization/{catalogId}/categories/{categoryId}`.replace(`{${"catalogId"}}`, encodeURIComponent(String(requestParameters['catalogId']))).replace(`{${"categoryId"}}`, encodeURIComponent(String(requestParameters['categoryId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateCatalogCategoryRequestToJSON(requestParameters['updateCatalogCategoryRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateCatalogCategory(requestParameters: UpdateCatalogCategoryOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateCatalogCategoryRaw(requestParameters, initOverrides);
    }

    /**
     */
    async updateCatalogDetailsRaw(requestParameters: UpdateCatalogDetailsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['catalogId'] == null) {
            throw new runtime.RequiredError(
                'catalogId',
                'Required parameter "catalogId" was null or undefined when calling updateCatalogDetails().'
            );
        }

        if (requestParameters['updateCatalogDetailsRequest'] == null) {
            throw new runtime.RequiredError(
                'updateCatalogDetailsRequest',
                'Required parameter "updateCatalogDetailsRequest" was null or undefined when calling updateCatalogDetails().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/catalogs/organization/{catalogId}/details`.replace(`{${"catalogId"}}`, encodeURIComponent(String(requestParameters['catalogId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateCatalogDetailsRequestToJSON(requestParameters['updateCatalogDetailsRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateCatalogDetails(requestParameters: UpdateCatalogDetailsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateCatalogDetailsRaw(requestParameters, initOverrides);
    }

    /**
     */
    async updateCatalogModifierGroupRaw(requestParameters: UpdateCatalogModifierGroupOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['catalogId'] == null) {
            throw new runtime.RequiredError(
                'catalogId',
                'Required parameter "catalogId" was null or undefined when calling updateCatalogModifierGroup().'
            );
        }

        if (requestParameters['groupId'] == null) {
            throw new runtime.RequiredError(
                'groupId',
                'Required parameter "groupId" was null or undefined when calling updateCatalogModifierGroup().'
            );
        }

        if (requestParameters['updateCatalogModifierGroupRequest'] == null) {
            throw new runtime.RequiredError(
                'updateCatalogModifierGroupRequest',
                'Required parameter "updateCatalogModifierGroupRequest" was null or undefined when calling updateCatalogModifierGroup().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/catalogs/organization/{catalogId}/modifier_groups/{groupId}`.replace(`{${"catalogId"}}`, encodeURIComponent(String(requestParameters['catalogId']))).replace(`{${"groupId"}}`, encodeURIComponent(String(requestParameters['groupId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateCatalogModifierGroupRequestToJSON(requestParameters['updateCatalogModifierGroupRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateCatalogModifierGroup(requestParameters: UpdateCatalogModifierGroupOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateCatalogModifierGroupRaw(requestParameters, initOverrides);
    }

    /**
     */
    async updateCourseRaw(requestParameters: UpdateCourseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['courseId'] == null) {
            throw new runtime.RequiredError(
                'courseId',
                'Required parameter "courseId" was null or undefined when calling updateCourse().'
            );
        }

        if (requestParameters['updateCatalogDetailsRequest'] == null) {
            throw new runtime.RequiredError(
                'updateCatalogDetailsRequest',
                'Required parameter "updateCatalogDetailsRequest" was null or undefined when calling updateCourse().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/catalogs/organization/course/{courseId}`.replace(`{${"courseId"}}`, encodeURIComponent(String(requestParameters['courseId']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateCatalogDetailsRequestToJSON(requestParameters['updateCatalogDetailsRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateCourse(requestParameters: UpdateCourseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateCourseRaw(requestParameters, initOverrides);
    }

    /**
     */
    async updateCoursesRaw(requestParameters: UpdateCoursesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/catalogs/organization/courses`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['createCatalogRequest']!.map(CreateCatalogRequestToJSON),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateCourses(requestParameters: UpdateCoursesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateCoursesRaw(requestParameters, initOverrides);
    }

    /**
     */
    async updateModifierRaw(requestParameters: UpdateModifierRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['modifierId'] == null) {
            throw new runtime.RequiredError(
                'modifierId',
                'Required parameter "modifierId" was null or undefined when calling updateModifier().'
            );
        }

        if (requestParameters['createModifierRequest'] == null) {
            throw new runtime.RequiredError(
                'createModifierRequest',
                'Required parameter "createModifierRequest" was null or undefined when calling updateModifier().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/catalogs/organization/modifier/{modifierId}`.replace(`{${"modifierId"}}`, encodeURIComponent(String(requestParameters['modifierId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateModifierRequestToJSON(requestParameters['createModifierRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateModifier(requestParameters: UpdateModifierRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateModifierRaw(requestParameters, initOverrides);
    }

    /**
     */
    async updateModifierGroupRaw(requestParameters: UpdateModifierGroupOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['modifierGroupId'] == null) {
            throw new runtime.RequiredError(
                'modifierGroupId',
                'Required parameter "modifierGroupId" was null or undefined when calling updateModifierGroup().'
            );
        }

        if (requestParameters['updateModifierGroupRequest'] == null) {
            throw new runtime.RequiredError(
                'updateModifierGroupRequest',
                'Required parameter "updateModifierGroupRequest" was null or undefined when calling updateModifierGroup().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/catalogs/organization/modifier-group/{modifierGroupId}`.replace(`{${"modifierGroupId"}}`, encodeURIComponent(String(requestParameters['modifierGroupId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateModifierGroupRequestToJSON(requestParameters['updateModifierGroupRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateModifierGroup(requestParameters: UpdateModifierGroupOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateModifierGroupRaw(requestParameters, initOverrides);
    }

    /**
     */
    async updateModifierGroupsRaw(requestParameters: UpdateModifierGroupsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/catalogs/organization/modifier-groups`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['updateModifierGroupsRequestInner']!.map(UpdateModifierGroupsRequestInnerToJSON),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateModifierGroups(requestParameters: UpdateModifierGroupsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateModifierGroupsRaw(requestParameters, initOverrides);
    }

    /**
     */
    async updateModifiersRaw(requestParameters: UpdateModifiersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/catalogs/organization/modifiers`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['updateModifiersRequestInner']!.map(UpdateModifiersRequestInnerToJSON),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateModifiers(requestParameters: UpdateModifiersRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateModifiersRaw(requestParameters, initOverrides);
    }

    /**
     */
    async updateOrganizationComboRaw(requestParameters: UpdateOrganizationComboOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['comboId'] == null) {
            throw new runtime.RequiredError(
                'comboId',
                'Required parameter "comboId" was null or undefined when calling updateOrganizationCombo().'
            );
        }

        if (requestParameters['updateOrganizationComboRequest'] == null) {
            throw new runtime.RequiredError(
                'updateOrganizationComboRequest',
                'Required parameter "updateOrganizationComboRequest" was null or undefined when calling updateOrganizationCombo().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/catalogs/organization/combo/{comboId}`.replace(`{${"comboId"}}`, encodeURIComponent(String(requestParameters['comboId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateOrganizationComboRequestToJSON(requestParameters['updateOrganizationComboRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateOrganizationCombo(requestParameters: UpdateOrganizationComboOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateOrganizationComboRaw(requestParameters, initOverrides);
    }

    /**
     */
    async updateProductRaw(requestParameters: UpdateProductRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['productId'] == null) {
            throw new runtime.RequiredError(
                'productId',
                'Required parameter "productId" was null or undefined when calling updateProduct().'
            );
        }

        if (requestParameters['createProductRequest'] == null) {
            throw new runtime.RequiredError(
                'createProductRequest',
                'Required parameter "createProductRequest" was null or undefined when calling updateProduct().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/catalogs/organization/product/{productId}`.replace(`{${"productId"}}`, encodeURIComponent(String(requestParameters['productId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateProductRequestToJSON(requestParameters['createProductRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateProduct(requestParameters: UpdateProductRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateProductRaw(requestParameters, initOverrides);
    }

}
